import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var BrokenLinkSvg = function BrokenLinkSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.005 4.586 7.623 2.249l-1.185.721L7.82 5.307zM13.2 3.338l-.922 2.336-1.283-.52.921-2.337zM4.38 6.592l2.764.467-.227 1.383-2.764-.467zM14.86 6.582H22v7.946h-7.14v-1.402h5.758V7.985h-5.757zM8.026 12.5l-.977-.992L2 16.631l5.537 5.618 5.049-5.123-.978-.991-4.071 4.131-3.583-3.635z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.085 11.256H14.4V9.854h3.685zM9.79 13.354l-2.741 2.781.977.991 2.74-2.78z"
  }));
};
export var BrokenLink = function BrokenLink(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: BrokenLinkSvg
  }));
};